__turbopack_context__.v({
  "BackLink": "qTxNOq_BackLink",
  "BackLinkLabel": "qTxNOq_BackLinkLabel",
  "Disclaimer": "qTxNOq_Disclaimer",
  "DisclaimerButtonContent": "qTxNOq_DisclaimerButtonContent",
  "DisclaimerButtonLink": "qTxNOq_DisclaimerButtonLink",
  "DisclaimerModalButton": "qTxNOq_DisclaimerModalButton",
  "DisclaimerText": "qTxNOq_DisclaimerText",
  "DisclaimerWrapper": "qTxNOq_DisclaimerWrapper",
  "Document": "qTxNOq_Document",
  "Flag": "qTxNOq_Flag",
  "HeadLineWrapper": "qTxNOq_HeadLineWrapper",
  "Header": "qTxNOq_Header",
  "Header--BackLink": "qTxNOq_Header--BackLink",
  "Header--HideTitle": "qTxNOq_Header--HideTitle",
  "Main": "qTxNOq_Main",
  "MobileMenu": "qTxNOq_MobileMenu",
  "Root": "qTxNOq_Root",
  "Root--ReportsPage": "qTxNOq_Root--ReportsPage",
  "Sidebar": "qTxNOq_Sidebar",
  "Sidebar--Hidden": "qTxNOq_Sidebar--Hidden",
  "Toolbar": "qTxNOq_Toolbar",
  "ToolbarWrapper": "qTxNOq_ToolbarWrapper",
  "skeleton-loading": "qTxNOq_skeleton-loading",
});
